import { Map } from 'immutable';

import {
    SET_ORGANIZATION_FILTER_COUNTRY,
    SET_ORGANIZATION_FILTER_SEARCH_TERM,
} from '../actions';

const filters = (state = Map({ country: 'AU', searchTerm: '' }), action) => {
  switch (action.type) {
    case SET_ORGANIZATION_FILTER_COUNTRY:
        return state.setIn(['country'], action.payload.country);
    case SET_ORGANIZATION_FILTER_SEARCH_TERM:
        return state.setIn(['searchTerm'], action.payload.searchTerm);
    default:
      return state;
  }
}

export default filters


// WEBPACK FOOTER //
// ./src/organizations/reducers/filter.js